"use client";

// ============================================================================
// ADMIN USER — REGISTRY DETAIL TAB COMPONENTS (public entry point)
// ============================================================================
// Self-contained tab display components rendered by the generic registry detail
// modal (UniversalDetailModalContainer) via useAdminUserDetailModalTabs. Each
// receives the already-fetched user as `item`. Ports the content of the bespoke
// UserDetailModal so the admin user detail view shares the same modal chrome,
// header, and navigation as contacts/companies/etc.
//
// The tabs themselves live in siblings (module-size); this file stays the one
// import path the tab registry uses.
// ============================================================================

import { AdminUserOverviewDisplay } from "./AdminUserOverviewDisplay";
import { AdminUserAccessDisplay } from "./AdminUserAccessDisplay";
import { AdminUserActivityDisplay } from "./AdminUserActivityDisplay";

export { Field, type AdminUserTabProps } from "./AdminUserFields";
export { AdminUserOverviewDisplay } from "./AdminUserOverviewDisplay";
export { AdminUserAccessDisplay } from "./AdminUserAccessDisplay";
export { AdminUserActivityDisplay } from "./AdminUserActivityDisplay";
export { AdminUserInfoPanel } from "./AdminUserInfoPanel";
export { AccessGrantList } from "./AccessGrantList";
// Re-exported from the shared helpers so there is ONE implementation; this file
// used to carry a byte-identical copy of userDisplayName + formatCentralDate.
export {
  userDisplayName,
  formatCentralDate,
} from "@/components/admin/users/UserDetailModal/user-detail-utils";

export const AdminUserDetailTabComponents = {
  AdminUserOverviewDisplay,
  AdminUserAccessDisplay,
  AdminUserActivityDisplay,
};
